
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/background-editor",
      function () {
        return require("private-next-pages/background-editor/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/background-editor"])
      });
    }
  